import { Component, EventEmitter, Output, ViewEncapsulation } from "@angular/core";
import { countries } from "./countries";
import { UserSandbox } from "../../../shared/sandbox/providers/user.sandbox";
import { FormBuilder, Validators } from "@angular/forms";
import { Select } from "@ngxs/store";
import { Observable } from "rxjs";
import { GlobalStateModel } from "../../../shared/model/global.model";
import { GlobalState } from "../../../shared/store/state/global.state";
import {
  SearchCountryField,
  TooltipLabel,
  CountryISO,
  PhoneNumberFormat,
} from "ngx-intl-tel-input";
import { DateFormatUtils } from "../../../shared/utils/date-format.utils";
import { CustomValidators } from "../custom-validators";
import { BioSealState } from "../../../shared/store/state/bioseal.state";
import { BioSealStateModel } from "../../../shared/model/bioseal.model";
import { take } from "rxjs/operators";
import { GlobalSandbox } from "../../../shared/sandbox/providers/global.sandbox";
@Component({
  selector: "id3-user-form",
  templateUrl: "./bioseal-user-form.component.html",
  styleUrls: ["./bioseal-user-form.component.css"],
  providers: [UserSandbox],
  encapsulation: ViewEncapsulation.None,
})
export class BiosealUserFormComponent {

  @Select(GlobalState.getGlobal) global: Observable<GlobalStateModel>;
  @Select(BioSealState.isPersonalDataLoaded) personalData: Observable<BioSealStateModel>;
  @Select(BioSealState.isDocumentDataLoaded) documentData: Observable<BioSealStateModel>;
  @Select(BioSealState.isPersonalFormSubmitted) personalSubmitted: Observable<BioSealStateModel>;
  @Select(BioSealState.isDocumentFormSubmitted) documentSubmitted: Observable<BioSealStateModel>;

  PersonalForm;
  DocumentForm;
  countriesToShow = countries;
  get Country() {
    return this.PersonalForm.get("country");
  }
  get gender() {
    return this.PersonalForm.get("gender");
  }
  get docType() {
    return this.DocumentForm.get("documentType");
  }

  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];

  @Output() nextEvent = new EventEmitter<boolean>();
  @Output() previousEvent = new EventEmitter<boolean>();

  constructor(private formBuilder: FormBuilder, public userSandbox: UserSandbox, public globalSandbox: GlobalSandbox) {
    this.PersonalForm = this.formBuilder.group({
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      dob: [""],
      pob: ["", Validators.required],
      gender: [null, Validators.required],
      address: [""],
      email: [
        "",
        [Validators.email, Validators.maxLength(50)],
      ],
      confirmEmail: [
        "",
        [
          Validators.email,
          this.userSandbox.EmailValidator("email"),
          Validators.maxLength(50),
        ],
      ],
      phoneNumber: [undefined],
      country: ["", Validators.required],
      id: [""]
    });
    this.PersonalForm.statusChanges.subscribe(() =>
      this.userSandbox.onPersonalFormValid({
        data: this.PersonalForm.value,
        validation: this.PersonalForm.valid,
      })
    );
    this.DocumentForm = this.formBuilder.group({
      documentType: [null],
      documentID: [""],
      dov: [DateFormatUtils.todayToStringDate(),
      [
        Validators.required,
        CustomValidators.dateValidator
      ]
      ],
      doe: [this.userSandbox.expiryDate],
      issuePlace: [""],
      fText: [""],
    });
    this.userSandbox.onDocumentFormValid({
      data: this.DocumentForm.value,
      validation: this.DocumentForm.valid
    });
    this.DocumentForm.statusChanges.subscribe(() =>
      this.userSandbox.onDocumentFormValid({
        data: this.DocumentForm.value,
        validation: this.DocumentForm.valid,
      })
    );
  }

  changeCountry(e) {
    this.Country.setValue(e.target.value, {
      onlySelf: true,
    });
  }

  changeGender(e) {
    this.gender.setValue(e.target.value, {
      onlySelf: true,
    });
  }

  changeDocType(e) {
    this.docType.setValue(e.target.value, {
      onlySelf: true,
    });
  }

  onPersonalSubmit() {
    this.personalData.pipe(take(1)).subscribe((loaded) => {
      loaded ? this.nextEvent.emit() : this.userSandbox.onPersonalFormSubmitted();
    });
  }

  onDocumentSubmit() {
    this.documentData.pipe(take(1)).subscribe((loaded) => {
      loaded ? this.nextEvent.emit() : this.userSandbox.onDocumentFormSubmitted();
    });
  }

  previous() {
    this.previousEvent.emit();
  }


}
